import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contact } from '../mock';

const WhatsAppFloat = () => (
  <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer"
     className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 grid place-items-center shadow-xl shadow-emerald-300/50 hover:scale-110 transition-all">
    <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-30" />
    <MessageCircle className="w-7 h-7 text-white relative" fill="white" />
  </a>
);

export default WhatsAppFloat;
